import {IntermediatePart} from "../../intermediatePart";

const widthAndHeightArray = ["Width", "Height"];

export default class Fridge extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'fridge';
    this.partName = 'Fridge';
    this.translateId = "visualizer.kitchen.appliance.fridge";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Fridge());
  }

  getFridgeWidthAndHeightConditions = () => {
    let widthHeightConditions = []
    if (!this.activeFeature || !this.activeFeature.metaData) {
      return widthHeightConditions
    }
    widthAndHeightArray.forEach(metaName => {
      if (this.activeFeature.metaData[metaName]) {
        widthHeightConditions.push({
          propName: metaName,
          propValue: Array.isArray(this.activeFeature.metaData[metaName])
            ? this.activeFeature.metaData[metaName][0]
            : this.activeFeature.metaData[metaName],
        })
      }
    });
    return widthHeightConditions
  }
}
